// extracted by mini-css-extract-plugin
export default {"stackDescription":"StackDescriptionEditor_stackDescription__b4qlH","stackDescriptionInput":"StackDescriptionEditor_stackDescriptionInput__xWvgT"};